// extracted by mini-css-extract-plugin
export default {"container-expanded":"Container_container-expanded__Ofn5i","container-collapsed":"Container_container-collapsed__Wci3Y"};